import {BaseModel} from "../base-model";

export class BaseLinkParams extends BaseModel {}
